interface CampaignNameLabelProps {
  /** The id of the campaign being viewed */
  campaignId?: number;
  /** Should the campaign id be shown? */
  shouldDisplayID?: boolean;
}

export default ({ campaignId, shouldDisplayID }: CampaignNameLabelProps) => (
  <>
    Campaign name
    {shouldDisplayID && <span>ID: {campaignId}</span>}
  </>
);
